import { render, staticRenderFns } from "./MenuAcademy.vue?vue&type=template&id=638f2196&scoped=true&"
import script from "./MenuAcademy.vue?vue&type=script&lang=js&"
export * from "./MenuAcademy.vue?vue&type=script&lang=js&"
import style0 from "./MenuAcademy.vue?vue&type=style&index=0&id=638f2196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f2196",
  null
  
)

export default component.exports